// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";


export interface IEmpty {

}
export class Empty implements IEmpty {


    constructor(data?: Partial<IEmpty>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
// tslint:disable-next-line:no-empty-interface
export class MEmpty extends Message implements Empty {

    constructor(data?: Partial<IEmpty>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
        }
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Empty() : {} as Empty;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IEmpty): Uint8Array {
        return (data instanceof Message ? (data as MEmpty) : new MEmpty(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MEmpty {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MEmpty();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MEmpty {
        return MEmpty.deserializeBinaryFromReader(new MEmpty(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MEmpty, reader: BinaryReader) {
        return Object.assign(msg, MEmpty.deserialize(reader))
    };

}
                        




export default () => {}